"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useTableData_1 = require("./useTableData");
var useMobileTableData_1 = require("./useMobileTableData");
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var MobileRow_1 = __importDefault(require("./MobileRow"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LimitsList = function (_a) {
    var limits = _a.limits;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var tableData = (0, useTableData_1.useTableData)(limits);
    var mobileTableData = (0, useMobileTableData_1.useMobileTableData)(limits);
    return (react_1.default.createElement("div", null, limits.length === 0 || !limits ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.emptyLimits }, t('emptyGameLimitsNotification'))) : (react_1.default.createElement(react_1.default.Fragment, null,
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && react_1.default.createElement(ui_components_1.DataTable, { data: tableData }),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("br", null),
            react_1.default.createElement(ui_components_1.MobileDataTable, { data: mobileTableData, rowComponent: MobileRow_1.default })))))));
};
exports.default = LimitsList;
